import React, { useState, useEffect } from 'react';
import { Modal, Form, Button, InputGroup } from "react-bootstrap";
import { BASE_URL } from "../../constants";
import axios from 'axios';
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const UserModal = ({ show, handleClose, onRowSelect }) => {

  const [searchUser, setSearchUser] = useState('');

  const [searchResults, setSearchResults] = useState([]);

  useEffect(() => {

    const fetchLists = async () => {
      try {

        populateGrid();

      } catch (err) {
        console.error("Dropdown fetch error:", err);
      }
    };

    fetchLists();

  }, []);


  const handleSearch = async () => {

    populateGrid();

  };

  const handleClear = async () => {

    setSearchUser('');
    setSearchResults([]);
    populateGrid();

  }

  const populateGrid = async () => {

    try {

      setSearchResults([]);

      const response = await axios.get(`${BASE_URL}/api/get_users`, {
                params: { userName: searchUser || '' }
            });

      setSearchResults(response.data);

    } catch (e) {

    }

  }

  return (
    <Modal show={show} onHide={handleClose} size="lg" centered backdrop="static" keyboard={false}>
      <Modal.Header closeButton>
        <Modal.Title>Search User</Modal.Title>
      </Modal.Header>

      <Modal.Body>

        <Form className="mb-3">
          {/* === Row 1 === */}
          <div className="row mb-3">

            {/* Section Dropdown */}
            <Form.Group className="col-md-8">
              <InputGroup>
                <InputGroup.Text style={{ width: "160px" }}>User Name / Login</InputGroup.Text>
                <input style={{ textAlign: 'left' }}
                  className="form-control"
                  name="searchUser"
                  value={searchUser}
                  onChange={(e) => setSearchUser(e.target.value)}
                />
              </InputGroup>
            </Form.Group>

            <div className="col-md-2">
              <Button variant="primary" onClick={handleSearch} className="w-100">
                Search
              </Button>
            </div>
            <div className="col-md-2">
              <Button variant="secondary" onClick={handleClear} className="w-100">
                Clear
              </Button>
            </div>

          </div>

        </Form>
        {/* <Table bordered hover responsive> */}
        <div style={{ minHeight: '430px' }} className="table-wrapper">
          <table style={{ maxHeight: '35px' }} className="responsive-table-modal scty-custom-table hover-table-rcpt">
            <thead>
              <tr>
                <th style={{ width: '20%', textAlign: 'left' }}>Login Id</th>
                <th style={{ width: '50%', textAlign: 'left' }}>User Name</th>
              </tr>
            </thead>
            <tbody>
              {searchResults.length === 0 ? (
                <tr><td colSpan="2" className="text-center">No Data</td></tr>
              ) : (
                searchResults.map((row, index) => (
                  <tr key={index} onClick={() => onRowSelect(row)} style={{ cursor: 'pointer' }}>
                    <td style={{ textAlign: 'left' }}>{row.login_id}</td>
                    <td style={{ textAlign: 'left' }}>{row.user_name}</td>
                  </tr>
                ))
              )}
            </tbody>
            {/* </Table> */}
          </table>
        </div>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="warning" onClick={handleClose}>Close</Button>
      </Modal.Footer>
    </Modal>
  );
};

export default UserModal;
